import React, { Component } from 'react';
import { Card, ButtonGroup, Button } from 'react-bootstrap';
import { GoX } from "react-icons/go";
import 'blob_types/blobhub/graph/orientdb/details/index.css';
import ProcessorDetails from './processor.js';
import ConnectionDetails from './connection.js';
import DefinitionDetails from './definition.js';
import "./index.css";

export default class DetailsPane extends Component {
  /**
   * UI Handlers
   */

  handleClose = () => {
    this.props.shell.shellInterface.toggleDetails();
  }

  /**
   * Rendering Section
   */

  renderContent() {
    if ( "processor" == this.props.shell.details.view ) {
      return (
        <ProcessorDetails shell={this.props.shell} />
      );
    } else if ( "connection" == this.props.shell.details.view ) {
      return (
        <ConnectionDetails shell={this.props.shell} />
      );
    } else {
      return (
        <DefinitionDetails shell={this.props.shell} />
      );
    }
  }

  render() {
    return (
      <Card>
        <Card.Body className="workflow-library-components">
          <span className="workflow-controls-pane-right">
            <Button variant="light" onClick={() => {
              this.props.shell.shellInterface.updatePane("details", false);
            }}><GoX/></Button>
          </span>

          {this.renderContent()}
        </Card.Body>
      </Card>
    );
  }
}
